<h2 mat-dialog-title>📂 Gerenciar Documentos</h2>

<mat-dialog-content class="dialog-content">
    <!-- Dica -->
    <p class="hint">Após fazer o upload, salve os arquivos.</p>

    <!-- Área de Upload -->
    <div class="upload-area">
        <button mat-raised-button color="primary" (click)="fileInput.click()">
            <i class="flaticon2-plus text-white icon-lg pointer"></i>
            Adicionar Arquivo
        </button>
        <input type="file" #fileInput (change)="onFileSelected($event)" multiple hidden>
    </div>

    <!-- Lista de anexos -->
    <div class="file-list">
        <mat-card *ngFor="let file of allFiles" class="file-card pointer">
            <mat-card-header>
                <i [ngClass]="getFileIcon(file.name)"> </i>
                <mat-card-title>{{ file.name }}</mat-card-title>
                <mat-card-subtitle>{{ (file.size / 1024) | number:'1.0-1' }} KB</mat-card-subtitle>
            </mat-card-header>
            <mat-card-actions class="d-flex justify-content-between align-items-center">
                <button mat-button color="warn" (click)="removeFile(file)">
                    <mat-icon>delete</mat-icon>
                </button>

                <button mat-button (click)="downloadFile(file)">
                    <i class="flaticon2-download text-success icon-lg pointer"></i>
                </button>

                <button *ngIf="file?.base64" mat-button (click)="openFile(file)">
                    <i class="fa fa-eye pointer"></i>
                </button>

            </mat-card-actions>
        </mat-card>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
    <button mat-raised-button color="accent" (click)="saveFiles()">
        <mat-icon>save</mat-icon> Salvar
    </button>

    <button mat-button (click)="closePopup()">Cancelar</button>

</mat-dialog-actions>